import { render, staticRenderFns } from "./AppointmentsTabs.vue?vue&type=template&id=fbef612e"
import script from "./AppointmentsTabs.vue?vue&type=script&lang=js"
export * from "./AppointmentsTabs.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsTabs.vue?vue&type=style&index=0&id=fbef612e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports